import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useLoading } from './LoadingProvider'

export default function PageLoader() {
  const { pathname } = useLocation()
  const { showPageLoading, hidePageLoading } = useLoading()

  useEffect(() => {
    showPageLoading()

    const timer = setTimeout(() => {
      hidePageLoading()
    }, 500)

    return () => clearTimeout(timer)
  }, [pathname, showPageLoading, hidePageLoading])

  return null
}
